import { render, staticRenderFns } from "./order-link.vue?vue&type=template&id=42755614&scoped=true&"
import script from "./order-link.vue?vue&type=script&lang=js&"
export * from "./order-link.vue?vue&type=script&lang=js&"
import style0 from "./order-link.vue?vue&type=style&index=0&id=42755614&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42755614",
  null
  
)

export default component.exports